<script>
  import Settings from "./Settings.svelte"
  import Modal from "./Modal.svelte"

  export let isLoading, dots, startAnimation, exportGif, loadingElem, settings, resetTerminal, updateData

  let triggerModal

  function handleUpload(props) {
    updateData(props)
    triggerModal()
  }
</script>

<div class="flex justify-center gap-4 my-12">
  <button on:click={startAnimation} disabled={isLoading} class="app-btn bg-lime-600">
    Simulate {loadingElem === "simulate" ? dots : ""}
  </button>
  <button on:click={exportGif} disabled={isLoading} class="app-btn bg-lime-600">
    Export {loadingElem === "export" ? dots : ""}
  </button>
  <Modal bind:trigger={triggerModal} on:close={resetTerminal}>
    <Settings
      slot="content"
      bind:isLoading
      bind:settings
      on:uploaded={handleUpload}
    />
    <button on:click={triggerModal} disabled={isLoading} class="app-btn bg-sky-600"> Settings </button>
  </Modal>
</div>

<style lang="postcss" scoped>
  button[disabled] {
    color: white;
    background-color: gray;
  }
</style>
